var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolIng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1777_2697)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.8333,
    cy: 24,
    r: 24,
    fill: "#C3F8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2716 40.1394C15.9128 42.9921 10.7301 45.8873 10.2601 45.5492C9.79001 45.211 10.32 39.9199 11.8071 36.3988C13.3437 32.7605 17.4656 30.8949 19.2282 32.1629C20.5207 33.0928 20.6303 37.2868 18.2716 40.1394Z",
    fill: "url(#paint0_linear_1777_2697)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1001 37.5578C17.7495 39.6026 12.6204 41.8424 12.3854 41.6751C12.0328 41.424 13.0986 35.7013 13.9293 34.1666C15.1292 31.9499 18.0526 31.5787 19.11 32.3976C20.1674 33.2165 20.4507 35.513 19.1001 37.5578Z",
    fill: "url(#paint1_linear_1777_2697)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4543 36.8572C16.7467 37.6795 13.9172 39.5811 13.7419 39.4551C13.5666 39.329 14.5272 36.0618 14.9621 35.2501C15.5205 34.2081 16.9792 33.7754 17.5752 34.2042C18.1713 34.633 18.1618 36.035 17.4543 36.8572Z",
    fill: "url(#paint2_linear_1777_2697)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9864 27.8975L17.2996 31.9184C15.3346 31.2499 12.6277 31.8982 10.4661 33.7437C10.2228 33.9534 9.99004 34.1751 9.76889 34.408C9.68123 34.4993 9.5618 34.5535 9.43541 34.5595C9.31442 34.5675 9.19436 34.5353 9.09403 34.468C8.88452 34.3294 8.78871 34.0763 8.8735 33.8602C9.20264 33.0132 9.62369 32.2043 10.1291 31.4478C12.726 27.5611 16.8972 25.7758 19.4451 27.4588C19.6394 27.5872 19.8207 27.7342 19.9864 27.8975Z",
    fill: "#7927E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2331 40.1019C22.7287 40.8593 22.1427 41.5598 21.4856 42.1906C21.3194 42.3518 21.0438 42.3609 20.8345 42.2227C20.7324 42.1568 20.6562 42.058 20.6187 41.9427C20.5754 41.8258 20.5801 41.6964 20.6318 41.5825C20.7615 41.289 20.876 40.9892 20.9746 40.6841C21.8491 37.9882 21.4005 35.2559 20.0194 33.7156L22.706 29.6944C22.9203 29.7825 23.1259 29.8905 23.3199 30.0168C25.8705 31.7014 25.8299 36.2152 23.2331 40.1019Z",
    fill: "#7927E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8074 29.6623L17.2997 31.9183C15.3346 31.2498 12.6278 31.8981 10.4662 33.7436C10.2228 33.9533 9.99008 34.1751 9.76893 34.4079C9.68128 34.4992 9.56184 34.5534 9.43545 34.5594C9.41037 34.481 9.41072 34.3965 9.43645 34.3181C9.68985 33.6223 10.027 32.9593 10.4404 32.3437C12.552 29.1831 16.13 27.8548 18.4356 29.3784C18.566 29.4644 18.6902 29.5592 18.8074 29.6623Z",
    fill: "#4810A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2858 40.1688C21.8749 40.7864 21.3902 41.3522 20.8425 41.8538C20.7807 41.9093 20.7012 41.9413 20.6182 41.9442C20.5749 41.8273 20.5796 41.698 20.6314 41.5841C20.7611 41.2906 20.8755 40.9907 20.9742 40.6856C21.8489 37.9883 21.4004 35.2559 20.0192 33.7157L21.5265 31.4599C21.6687 31.5281 21.8058 31.6063 21.9369 31.6938C24.2408 33.2139 24.3974 37.0082 22.2858 40.1688Z",
    fill: "#4810A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3145 36.4318C20.7128 37.3369 18.637 37.0163 16.6816 35.7226C14.7262 34.4288 13.6261 32.6445 14.2302 31.7392C14.8344 30.834 16.9078 31.1547 18.8632 32.4485C20.8185 33.7423 21.917 35.5273 21.3145 36.4318Z",
    fill: "#8A40FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0143 37.5515C29.942 37.6276 29.8538 37.6869 29.7561 37.7252C29.6584 37.7636 29.5535 37.78 29.4488 37.7734L29.1407 37.7627C28.9605 37.755 28.7877 37.6897 28.6477 37.5765C28.5076 37.4633 28.4078 37.3082 28.3628 37.1339C28.3205 36.9734 28.3381 36.8029 28.4124 36.6541C28.4907 36.497 28.5653 36.3339 28.6321 36.1655C29.8943 32.9879 28.495 29.3689 25.5078 28.0816C25.3633 28.02 25.2208 27.9691 25.076 27.9206C24.8915 28.1745 24.6993 28.4231 24.4953 28.6704C24.1354 29.1069 23.7525 29.5242 23.3484 29.9203C23.3402 29.9258 23.3331 29.9326 23.3273 29.9406C23.2287 30.0375 23.1032 30.1026 22.9672 30.1275C22.4884 30.2128 21.9473 29.805 22.0032 29.2532C22.0511 28.7676 22.0378 28.2779 21.9636 27.7958C21.4885 27.9123 21.0305 28.09 20.6011 28.3244C20.1129 28.5899 19.5232 28.2488 19.4193 27.7775C19.3893 27.6428 19.4008 27.502 19.4523 27.3738C19.455 27.3637 19.4603 27.356 19.4629 27.3466C19.6714 26.8215 19.9076 26.3077 20.1703 25.8074C20.3239 25.5252 20.4793 25.2525 20.6427 24.9844C20.5413 24.8686 20.437 24.7571 20.3264 24.6498C17.9782 22.4032 14.0873 22.5184 11.6391 24.9105C11.509 25.0371 11.3878 25.1705 11.272 25.3018C11.1629 25.4261 11.0138 25.5086 10.8505 25.535C10.6721 25.5612 10.49 25.5296 10.3312 25.4449C10.1723 25.3601 10.045 25.2267 9.96788 25.0641L9.83615 24.7838C9.79059 24.69 9.76596 24.5875 9.76394 24.4832C9.76192 24.3789 9.78256 24.2754 9.82445 24.1797C10.5025 22.7001 11.5319 21.2289 12.8822 19.9094C17.1029 15.7883 22.8622 14.6917 25.7532 17.4572C26.4687 18.1396 26.941 18.999 27.1851 19.9656C28.1713 19.8135 29.1463 19.9125 30.0572 20.3074C33.7321 21.8906 34.9502 27.6097 32.7774 33.0866C32.0802 34.8384 31.1168 36.3529 30.0143 37.5515Z",
    fill: "#1DD1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8906 36.9632C28.827 37.0264 28.7502 37.0747 28.6657 37.1047C28.5812 37.1347 28.4911 37.1456 28.402 37.1366L28.3624 37.1332C28.3201 36.9727 28.3377 36.8021 28.412 36.6533C28.4903 36.4963 28.5649 36.3332 28.6317 36.1648C29.8939 32.9871 28.4946 29.3681 25.5074 28.0809C25.3629 28.0192 25.2204 27.9683 25.0755 27.9199C24.8911 28.1738 24.6989 28.4224 24.4949 28.6696C24.428 28.6446 24.3569 28.6201 24.2899 28.5951C23.8933 29.142 23.4505 29.6542 22.9664 30.1259C22.9225 30.1687 22.8744 30.2129 22.8304 30.2557C22.8216 30.2598 22.8191 30.2672 22.8111 30.2733C22.3871 30.6758 21.5855 30.2469 21.63 29.6507C21.6606 29.2332 21.6361 28.8136 21.5574 28.4027C21.1463 28.4892 20.7481 28.6289 20.373 28.8182C19.8382 29.0904 19.1344 28.5217 19.3404 27.9752C19.3456 27.9675 19.3463 27.9604 19.3516 27.9526C19.3737 27.894 19.3958 27.8354 19.4179 27.7767C19.665 27.1482 19.9659 26.5419 20.3173 25.9647C20.2681 25.9132 20.2205 25.859 20.1686 25.8058C20.3222 25.5237 20.4775 25.2509 20.6409 24.9828C20.5396 24.867 20.4353 24.7555 20.3247 24.6483C17.9764 22.4016 14.0855 22.5168 11.6374 24.9089C11.5073 25.0356 11.386 25.1689 11.2702 25.3002C11.1611 25.4245 11.0121 25.507 10.8488 25.5334L10.8325 25.4976C10.7893 25.419 10.7641 25.3317 10.7587 25.2422C10.7534 25.1526 10.7679 25.0629 10.8014 24.9796C11.3568 23.7344 12.2184 22.5043 13.3703 21.4144C16.9547 18.0129 21.9823 17.2346 24.5931 19.674C25.2266 20.2673 25.685 21.0227 25.9187 21.8583C26.7807 21.7487 27.6557 21.8771 28.4485 22.2298C31.7182 23.6861 32.9451 28.6071 31.1927 33.2218C30.6295 34.7009 29.8289 35.9708 28.8906 36.9632Z",
    fill: "#2B8081"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1777_2697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2941 29.0817C24.469 36.3242 20.8212 36.2964 17.6819 34.2171C14.5425 32.1379 13.1074 28.7951 17.9307 21.555C20.192 18.1635 23.4176 14.5226 26.5392 11.8212C26.634 11.7358 26.7298 11.6549 26.8252 11.5741C29.1336 9.60947 31.3602 8.18351 33.0682 7.78037C33.8034 7.60679 34.4434 7.62078 34.9495 7.8647C35.0216 7.90041 35.0915 7.94037 35.1589 7.98439C35.214 8.02105 35.2652 8.05856 35.314 8.09856C36.7578 9.30154 36.403 12.8791 35.073 17.0371C35.0354 17.1563 34.9975 17.2755 34.9555 17.3957C33.6685 21.3126 31.5528 25.691 29.2941 29.0817Z",
    fill: "url(#paint3_linear_1777_2697)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1777_2697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9163 27.1188C20.7433 31.8817 13.4567 31.1967 15.5743 25.8799C16.0778 24.6158 16.8461 23.1844 17.9311 21.5558C20.2603 18.0596 23.6172 14.2988 26.8256 11.5749C27.5561 10.9532 28.2784 10.3855 28.9786 9.88699C30.6879 8.67029 32.3786 10.216 31.6308 12.1763C29.7618 17.0656 26.8596 22.7018 23.9163 27.1188Z",
    fill: "url(#paint4_linear_1777_2697)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.9555 17.3957C33.4798 16.908 31.9149 16.1488 30.3916 15.1398L30.3547 15.1153C28.8458 14.1125 27.5536 12.9792 26.5392 11.8212C26.6339 11.7359 26.7298 11.6549 26.8252 11.5742C29.1336 9.60949 31.3601 8.18354 33.0682 7.78039C33.8033 7.60682 34.4433 7.6208 34.9494 7.86473C35.0216 7.90043 35.0915 7.9404 35.1588 7.98442C35.214 8.02108 35.2651 8.05859 35.314 8.09859C36.7578 9.30157 36.403 12.8791 35.0729 17.0372C35.0354 17.1563 34.9969 17.2744 34.9555 17.3957Z",
    fill: "#4810A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.073 17.0371C33.6233 16.5895 32.078 15.8584 30.576 14.8631L30.5413 14.8404C29.0538 13.8512 27.795 12.7251 26.8252 11.5741C26.9754 11.4456 27.1286 11.3191 27.2765 11.1931C27.4138 11.0822 27.5498 10.9718 27.6858 10.8644C27.8217 10.7569 27.9631 10.6412 28.1038 10.5335C28.7928 9.99786 29.5103 9.49968 30.253 9.04118C30.3533 8.98199 30.4486 8.92362 30.5474 8.86756C31.267 8.44835 31.9494 8.12527 32.5755 7.92102C32.6307 7.90082 32.6869 7.88502 32.7431 7.86922C32.8499 7.83417 32.9584 7.80449 33.0682 7.78031C33.9076 7.58078 34.6235 7.6298 35.1592 7.98415C36.7824 9.05948 36.4482 12.738 35.073 17.0371Z",
    fill: "#A45CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5413 14.8404C29.0538 13.8512 27.795 12.7251 26.8252 11.5741C26.9754 11.4456 27.1286 11.3191 27.2765 11.1931C27.4138 11.0822 27.5498 10.9718 27.6858 10.8644C27.8217 10.7569 27.9631 10.6412 28.1038 10.5335C28.7928 9.99786 29.5102 9.49969 30.2529 9.04118C30.3533 8.982 30.4486 8.92363 30.5474 8.86756C31.267 8.44835 31.9494 8.12528 32.5755 7.92103C32.6307 7.90083 32.6869 7.88503 32.743 7.86922C32.8529 7.83535 32.9611 7.80419 33.0682 7.78031C32.7166 9.12336 32.2273 10.6106 31.6304 12.1754C31.2976 13.0439 30.9354 13.9354 30.5413 14.8404Z",
    fill: "#8A40FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4978 25.5965C28.1801 27.5748 25.3662 28.022 23.2128 26.5961C21.0595 25.1702 20.3822 22.4099 21.6997 20.4313C23.0172 18.4526 25.8314 18.0058 27.9845 19.4323C30.1376 20.8588 30.8153 23.6189 29.4978 25.5965Z",
    fill: "#8A40FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5028 24.9381C27.5213 26.4108 25.4241 26.7448 23.8207 25.6829C22.2172 24.6209 21.7129 22.5655 22.694 21.092C23.6751 19.6185 25.7704 19.2858 27.3761 20.3472C28.9817 21.4086 29.4838 23.4646 28.5028 24.9381Z",
    fill: "#A45CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.082 24.6588C27.2411 25.9194 25.4507 26.2035 24.0794 25.2952C22.708 24.3868 22.2772 22.6294 23.1161 21.3697C23.9549 20.11 25.7471 19.8256 27.1167 20.7343C28.4863 21.643 28.9211 23.3996 28.082 24.6588Z",
    fill: "#140D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6011 24.3407C26.9243 25.3562 25.4792 25.586 24.3736 24.8539C23.268 24.1217 22.9202 22.7037 23.597 21.6882C24.2738 20.6727 25.7184 20.4427 26.8246 21.1751C27.9308 21.9074 28.2778 23.3248 27.6011 24.3407Z",
    fill: "#351567"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7237 23.142C27.5152 23.0935 27.5206 22.2406 27.0677 21.7767C26.7031 21.4034 26.1188 21.1687 25.6091 21.1315C24.9162 21.0804 24.2057 21.3919 23.8139 21.9737C23.6098 22.2754 23.5394 22.7385 23.9078 22.9487C24.2988 23.172 24.41 22.8396 24.7169 22.7984C25.1759 22.7357 25.4824 22.786 25.9163 22.9825C26.1687 23.0993 26.4455 23.1539 26.7237 23.142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4332 23.8258C27.6512 23.284 26.5122 23.4797 26.91 23.9177C27.0526 24.0759 27.3544 24.0214 27.4332 23.8258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.366 3.74551L37.8384 3.39612L35.3412 7.14518L35.8688 7.49457L38.366 3.74551Z",
    fill: "#D8D0ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8367 3.3992L35.3389 7.14783L35.6146 7.33052L38.1124 3.58188L37.8367 3.3992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2086 8.55047C35.8743 9.05173 35.1615 9.16509 34.6173 8.80291C34.0731 8.44072 33.8999 7.74184 34.2338 7.24076C34.5677 6.73967 35.2808 6.62613 35.8251 6.98832C36.3693 7.35051 36.5423 8.04898 36.2086 8.55047Z",
    fill: "#1DD1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3576 7.45179C35.2669 7.59018 35.0713 7.61978 34.9216 7.52107C34.772 7.42236 34.7253 7.23068 34.8168 7.0939C34.8408 7.06062 34.8711 7.03241 34.9061 7.01089C34.9411 6.98937 34.98 6.97497 35.0205 6.96853C35.0611 6.96209 35.1025 6.96372 35.1423 6.97335C35.1822 6.98298 35.2198 7.0004 35.2528 7.02462C35.402 7.12351 35.4489 7.3146 35.3576 7.45179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8565 3.5012C38.6904 3.7506 38.3357 3.80677 38.0641 3.62739C37.7925 3.44801 37.7073 3.09941 37.8733 2.85001C38.0394 2.60061 38.3945 2.54425 38.6659 2.72422C38.9373 2.90419 39.0229 3.25162 38.8565 3.5012Z",
    fill: "#1DD1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4449 2.91005C38.43 2.93779 38.407 2.96038 38.3789 2.97485C38.3509 2.98932 38.3192 2.99498 38.2879 2.9911C38.2566 2.98722 38.2272 2.97398 38.2037 2.95312C38.1801 2.93225 38.1635 2.90474 38.1559 2.87421C38.1483 2.84368 38.1502 2.81156 38.1613 2.78207C38.1724 2.75258 38.1921 2.72711 38.218 2.709C38.2438 2.6909 38.2745 2.68101 38.306 2.68065C38.3376 2.68028 38.3684 2.68945 38.3946 2.70695C38.428 2.72745 38.4519 2.76019 38.4613 2.79816C38.4707 2.83612 38.4649 2.87629 38.4449 2.91005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3806 13.6557C26.1008 13.9305 25.8182 14.2026 25.5328 14.4719L24.719 15.3071L23.9336 16.1674L23.1816 17.0528L22.4606 17.9635L21.7703 18.8957L21.1123 19.8496L20.4895 20.8265L19.8982 21.8241L19.3445 22.8414L18.8224 23.8756L18.3394 24.9294C18.1851 25.2838 18.042 25.6428 17.8923 26L17.4823 27.0877L17.1112 28.1883L16.781 29.3103L16.701 29.2864L16.9423 28.8132L16.7788 29.3181L16.6987 29.2942C16.7588 28.9083 16.8141 28.5192 16.8849 28.1332C16.9703 27.7504 17.0486 27.3649 17.1429 26.9843C17.2517 26.6069 17.3501 26.2249 17.4688 25.8498C17.5978 25.4782 17.721 25.1034 17.8561 24.7335C18.0001 24.3674 18.149 24.0023 18.3028 23.6383C18.4685 23.2812 18.6268 22.9192 18.8002 22.5648L19.3528 21.5183C19.5532 21.1784 19.7444 20.8331 19.9514 20.497L20.6003 19.5068L21.2928 18.5464L22.0315 17.6219C22.2883 17.3225 22.554 17.0307 22.8154 16.736C23.0898 16.4525 23.3621 16.1679 23.6411 15.8905L24.5105 15.0908L25.4244 14.3428C25.7403 14.1079 26.0601 13.8815 26.3806 13.6557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1777_2697)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8768 6.21763C14.8828 6.12832 14.8859 6.0382 14.8859 5.94737C14.8859 3.7673 13.1186 2 10.9385 2C8.97497 2 7.34627 3.43368 7.04212 5.31134C6.78093 5.21218 6.49764 5.15789 6.20167 5.15789C4.89363 5.15789 3.83325 6.21827 3.83325 7.52632C3.83325 8.83436 4.89363 9.89474 6.20167 9.89474C6.24736 9.89474 6.29275 9.89344 6.33781 9.89089C6.24966 10.1389 6.20167 10.406 6.20167 10.6842C6.20167 11.9923 7.26205 13.0526 8.57009 13.0526C9.17669 13.0526 9.73003 12.8246 10.149 12.4496C10.5681 12.8246 11.1214 13.0526 11.728 13.0526C13.036 13.0526 14.0964 11.9923 14.0964 10.6842C14.0964 10.6708 14.0963 10.6574 14.0961 10.644C14.5976 11.156 15.2968 11.4737 16.0701 11.4737C17.5961 11.4737 18.8333 10.2366 18.8333 8.71053C18.8333 7.18448 17.5961 5.94737 16.0701 5.94737C15.6427 5.94737 15.238 6.0444 14.8768 6.21763Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6068 25.3706C42.426 25.459 42.2265 25.5165 42.0143 25.536C41.4606 25.5868 40.9446 25.3668 40.5972 24.985C40.4413 25.044 40.2749 25.0832 40.1008 25.0992C39.0649 25.1942 38.1482 24.4315 38.0531 23.3956C37.9581 22.3597 38.7208 21.4429 39.7567 21.3479C40.0081 21.3248 40.2524 21.3523 40.4797 21.4219C40.5925 20.7096 41.176 20.1369 41.927 20.068C42.3387 20.0302 42.7285 20.1505 43.0363 20.379C43.2974 20.0983 43.6588 19.9091 44.0706 19.8713C44.9585 19.7899 45.7443 20.4436 45.8257 21.3315C45.8431 21.5204 45.8271 21.7046 45.7828 21.8784C45.8132 21.8739 45.8439 21.8702 45.8749 21.8673C46.7628 21.7859 47.5487 22.4396 47.6301 23.3276C47.7116 24.2155 47.0578 25.0013 46.1699 25.0827C45.9436 25.1035 45.7238 25.0765 45.5207 25.01C45.2805 25.5618 44.7547 25.9692 44.113 26.028C43.5098 26.0834 42.9512 25.8172 42.6068 25.3706ZM43.2575 22.7767C43.2562 22.7773 43.2549 22.7779 43.2535 22.7785C43.2544 22.7776 43.2553 22.7766 43.2562 22.7757C43.2566 22.776 43.2571 22.7763 43.2575 22.7767Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1777_2697",
    x: 12.804,
    y: 6.66382,
    width: 25.4417,
    height: 31.7589,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1777_2697"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1777_2697",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1777_2697",
    x: 13.1946,
    y: 8.45557,
    width: 20.6182,
    height: 24.858,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1777_2697"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1777_2697",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1777_2697",
    x: -0.166748,
    y: -2,
    width: 23,
    height: 19.0526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.779236 0 0 0 0 0.954167 0 0 0 0 0.940964 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1777_2697"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1777_2697",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1777_2697",
    x1: 16.7941,
    y1: 34.7798,
    x2: 10.8801,
    y2: 46.4503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#FF2400",
    stopOpacity: 0.77
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1777_2697",
    x1: 17.6171,
    y1: 34.8944,
    x2: 12.9281,
    y2: 42.1415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9700",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1777_2697",
    x1: 17.501,
    y1: 34.4267,
    x2: 14.3268,
    y2: 39.6915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC83",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1777_2697",
    x1: 20.9634,
    y1: 16.2909,
    x2: 27.9786,
    y2: 32.2153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#F3F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525052,
    stopColor: "#EFE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1777_2697",
    x1: 16.5202,
    y1: 17.4167,
    x2: 30.0427,
    y2: 30.0096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#F3F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525052,
    stopColor: "#EFE8FF",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8EAFF",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1777_2697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.833252)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolIng);
export default __webpack_public_path__ + "static/media/symbol-ing.e25682234abc91437bc5b9066a918904.svg";
export { ForwardRef as ReactComponent };